<template>
  <b-card>
    <b-row style="margin-right:0px !important">
      <b-col cols="3" md="3" xl="3">
          <b-list-group>
              <b-list-group-item id="button-list-group-item" :variant="getVariant(item)" v-for="item in commonList" :key="item.id" @click="selectContact(item)">
                <b-row>
                  <b-col>
                    {{ item.name }}
                  </b-col>
                  <b-col>
                    <div v-if="item.isTable">
                      <b-button size="sm" @click.stop="deleteContacts(item)" id="transparent">
                        <b-img :src='deleteDocumentImage' style="width:16px;height:16px;"/>
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-list-group-item>
              <b-list-group-item id="button-list-group-item">
                <b-button @click.stop="showAddContact" variant="success">{{ $t('Add') }}</b-button>
              </b-list-group-item>
          </b-list-group>
      </b-col>
      <b-col cols="9" md="9" xl="9">
        <b-card style="margin: 1%" v-if="curItem">
          <b-form-group :label="curItem.name" label-size="lg" style="margin:1px"/>
            <b-row style="margin-left:5px">
              <b-col>
                <b-form-group label-align="right" :label="$t('Position name')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
                  <b-form-input v-model="curItem.descr"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
                  <b-form-input v-model="curItem.person"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Telephone')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
                  <b-form-input v-model="curItem.contact"/>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label-align="right" :label="$t('Reason')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
                  <b-form-input v-model="curItem.reason"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Short name')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
                  <b-form-input v-model="curItem.person_short"/>
                </b-form-group>
                <b-form-group label-align="right" label="E-mail" label-cols="4" label-cols-xl="4" label-cols-md="4" >
                  <b-form-input v-model="curItem.email"/>
                </b-form-group>
              </b-col>
            </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-modal hide-footer :title="$t('Contact')" ref="modalAddContacts">
      <b-form @submit="addContact">
        <b-card>
          <b-row>
            <b-col >
              <b-form-group label-align="right" :label="$t('Full name')" label-class="text-sm-right" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="newContact.person" required/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Short person`s name')" label-class="text-sm-right" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="newContact.person_short" required/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Position')" label-class="text-sm-right" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="newContact.descr" required/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Contact')" label-class="text-sm-right" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="newContact.contact"/>
              </b-form-group>
              <b-form-group label-align="right" label="E-mail" label-class="text-sm-right" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="newContact.email"/>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-row style="margin:1%">
          <b-col>
            <b-button variant="success" style="float: right; width: 100px" type="submit">Ok</b-button>
          </b-col>
          <b-col sm="3">
              <b-button  variant="secondary" style="float: right; width: 100px" @click.stop="hideAddContact">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </b-card>
</template>

<script>
export default {
  props: {
    ceo: null,
    accountant: null,
    tableContacts: null
  },
  data () {
    return {
      newContact: {
        'person': '',
        'person_short': '',
        'descr': '',
        'contact': '',
        'email': '',
        'id_exec_man': 0,
        'reason': ''
      },
      empertyContact: {
        'person': '',
        'person_short': '',
        'descr': '',
        'contact': '',
        'email': '',
        'id_exec_man': 0,
        'reason': ''
      },
      deleteDocumentImage: require('@/assets/img/document_delete.png'),
      editDocumentImage: require('@/assets/img/document_edit.png'),
      fieldsContacts: [
        { key: 'person', label: this.$i18n.t('Full name'), sortable: true },
        { key: 'person_short', label: this.$i18n.t('Short name'), sortable: true },
        { key: 'descr', label: this.$i18n.t('Position'), sortable: true },
        { key: 'contact', label: this.$i18n.t('Contact'), sortable: true },
        { key: 'email', label: 'E-mail', sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions'), sortable: true }
      ],
      isEdit: false,
      curItem: null,
      contactData: null,
      commonList: []
    }
  },
  methods: {
    rowClickHandler (row) {
      if (this.selectContact) {
        this.selectContact._rowVariant = ''
      }
      this.selectContact = row
      this.$set(this.selectContact, '_rowVariant', 'info')
    },
    ClickOnEditContactsButton (row) {
      this.selectContact = row.item
      this.showEditContact()
    },
    deleteContacts (item) {
      this.selectContact = item
      this.$emit('deleteContact', this.selectContact)
      this.commonList = this.commonList.filter((value) => {
        return value !== item
      })
    },
    showAddContact () {
      this.newContact = JSON.parse(JSON.stringify(this.empertyContact))
      this.isEdit = false
      this.$refs.modalAddContacts.show()
    },
    showEditContact () {
      this.newContact = this.selectContact
      this.isEdit = true
      this.$refs.modalAddContacts.show()
    },
    hideAddContact () {
      this.$refs.modalAddContacts.hide()
    },
    addContact () {
      if (!this.isEdit) {
        this.newContact.name = this.newContact.person
        this.newContact.isTable = true
        this.commonList.push(this.newContact)
        this.tableContacts.push(this.newContact)
      }
      this.hideAddContact()
    },
    selectContact (item) {
      this.curItem = item === this.curItem ? null : item
    },
    getVariant (item) {
      if (this.curItem) {
        if (item === this.curItem) {
          return 'info'
        }
      }
      return 'default'
    }
  },
  mounted () {
    this.ceo.name = this.$t('CEO')
    this.commonList.push(this.ceo)
    this.accountant.name = this.$t('Accountant')
    this.commonList.push(this.accountant)
    for (let el of this.tableContacts) {
      el.name = el.person
      el.isTable = true
    }
    this.commonList = this.commonList.concat(this.tableContacts)
    this.curItem = this.commonList[0]
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/additionalContacts/main.vue